import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { KeycloakService } from 'keycloak-angular';
import { provideEchartsCore } from 'ngx-echarts';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { AuthService } from './core/services/auth.service';
import { ThemeService } from './core/services/theme.service';
import { BrandingService } from './core/services/branding.service';
import { UserConfigService } from './core/services/user-config.service';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

function initApp(keycloak: KeycloakService, auth: AuthService, themes: ThemeService, branding: BrandingService, userConfig: UserConfigService) {
  return async () => {
    // keycloak.init() DEVE poter rigettare: senza autenticazione non c'è app,
    // e il suo onLoad:'login-required' gestisce da sé il redirect. Tutto il
    // resto (tema, branding, profilo, config utente) è best-effort: un loro
    // errore non deve impedire il render (causava schermo bianco al primo login).
    await themes.init().catch(e => console.error('themes.init', e));
    await branding.init().catch(e => console.error('branding.init', e));

    await keycloak.init({
      config: {
        url: environment.keycloakUrl,
        realm: environment.keycloakRealm,
        clientId: environment.keycloakClientId,
      },
      initOptions: {
        onLoad: 'login-required',
        pkceMethod: 'S256',
        checkLoginIframe: false,
      },
      enableBearerInterceptor: false,
    });
    await auth.init();              // già difensivo internamente
    await userConfig.init();        // già difensivo internamente
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    provideEchartsCore({ echarts: () => import('echarts') }),
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [KeycloakService, AuthService, ThemeService, BrandingService, UserConfigService],
      multi: true,
    },
  ],
};
